import { render, staticRenderFns } from "./PersonVisa.vue?vue&type=template&id=043af2e8"
import script from "./PersonVisa.vue?vue&type=script&lang=js"
export * from "./PersonVisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports